module.exports = __webpack_public_path__ + "img/product15.62429bc9.jpg";